const state = {
    bulb_complexity: 0,
    complexity_levels: [],
    nsf_id: 0, // id of the current nsf stream
    segment_complexity: {},
    treatment: null,
}
export default state;
